import { useQuery } from '@tanstack/react-query'
import { lcCoachingApi } from '@/api/lcCoaching'
import { coachingKeys } from './useCoachingToday'

// 원생의 콘텐츠 트리(과정>코스>모듈(=챕터)>레슨 + 노드 집계). range 기본 'all'.
export function useLibrary(learnerId: number, range = 'all') {
  return useQuery({
    queryKey: coachingKeys.library(learnerId, range),
    queryFn: () => lcCoachingApi.getLibrary(learnerId, range),
    enabled: Number.isFinite(learnerId) && learnerId > 0,
    staleTime: 30_000,
  })
}
